module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-2-en-GB-2b2951a41d68143d0493e85eac34f4ce.png";